<template>
  <page-header-wrapper>
    <a-space direction="vertical">
      <a-row :gutter="24">
        <a-col :span="24">
          <a-card :loading="loading" :title="$t('monitor.cache.basicInfo')" :bordered="false">
            <a-descriptions :column="4">
              <a-descriptions-item :label="$t('monitor.cache.redisVersion')">
                <span v-if="cache.info">{{ cache.info.redis_version }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.runMode')">
                <span v-if="cache.info">{{ redisModeText }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.port')">
                <span v-if="cache.info">{{ cache.info.tcp_port }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.clients')">
                <span v-if="cache.info">{{ cache.info.connected_clients }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.uptimeDays')">
                <span v-if="cache.info">{{ cache.info.uptime_in_days }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.usedMemory')">
                <span v-if="cache.info">{{ cache.info.used_memory_human }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.usedCpu')">
                <span v-if="cache.info">{{ parseFloat(cache.info.used_cpu_user_children).toFixed(2) }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.memoryConfig')">
                <span v-if="cache.info">{{ cache.info.maxmemory_human }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.aofEnabled')">
                <span v-if="cache.info">{{ aofEnabledText }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.rdbStatus')">
                <span v-if="cache.info">{{ cache.info.rdb_last_bgsave_status }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.keyCount')">
                <span v-if="cache.dbSize">{{ cache.dbSize }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('monitor.cache.networkKps')">
                <span v-if="cache.info">{{ cache.info.instantaneous_input_kbps }}kps/{{ cache.info.instantaneous_output_kbps }}kps</span>
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-card :loading="loading" :title="$t('monitor.cache.commandStats')" :bordered="false">
            <div ref="commandstats" style="height: 420px" />
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card :loading="loading" :title="$t('monitor.cache.memoryInfo')" :bordered="false">
            <div ref="usedmemory" style="height: 420px" />
          </a-card>
        </a-col>
      </a-row>
    </a-space>
  </page-header-wrapper>
</template>

<script>

import { getCache } from '@/api/monitor/cache'
import * as echarts from 'echarts'

export default {
  name: 'Cache',
  data () {
    return {
      loading: true,
      commandstats: null,
      usedmemory: null,
      cache: {},
      commandStatsData: []
    }
  },
  created () {
    this.getList()
  },
  computed: {
    redisModeText () {
      if (!this.cache.info) {
        return ''
      }
      return this.cache.info.redis_mode === 'standalone'
        ? this.$t('monitor.cache.standalone')
        : this.$t('monitor.cache.cluster')
    },
    aofEnabledText () {
      if (!this.cache.info) {
        return ''
      }
      return this.cache.info.aof_enabled === '0' ? this.$t('common.no') : this.$t('common.yes')
    }
  },
  watch: {
    '$i18n.locale' () {
      this.renderCharts()
    }
  },
  methods: {
    getList () {
      this.loading = true
      getCache().then(response => {
        this.cache = response.data
        this.commandStatsData = response.data.commandStats
        this.loading = false
        this.$nextTick(() => {
          if (!this.commandstats) {
            this.commandstats = echarts.init(this.$refs.commandstats, 'macarons')
          }
          if (!this.usedmemory) {
            this.usedmemory = echarts.init(this.$refs.usedmemory, 'macarons')
          }
          this.renderCharts()
        })
      })
    },
    renderCharts () {
      if (!this.cache.info || !this.commandstats || !this.usedmemory) {
        return
      }
      this.commandstats.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            name: this.$t('monitor.cache.chartCommand'),
            type: 'pie',
            roseType: 'radius',
            radius: [15, 95],
            center: ['50%', '38%'],
            data: this.commandStatsData,
            animationEasing: 'cubicInOut',
            animationDuration: 1000
          }
        ]
      })
      this.usedmemory.setOption({
        tooltip: {
          formatter: '{b} <br/>{a} : ' + this.cache.info.used_memory_human
        },
        series: [
          {
            name: this.$t('monitor.cache.chartPeak'),
            type: 'gauge',
            min: 0,
            max: 1000,
            detail: {
              formatter: this.cache.info.used_memory_human
            },
            data: [
              {
                value: parseFloat(this.cache.info.used_memory_human),
                name: this.$t('monitor.cache.chartMemoryConsumption')
              }
            ]
          }
        ]
      })
    }
  }
}
</script>
